import axios from "axios";
import { useState } from "react";
import { useOutletContext } from "react-router-dom";
import toastr from "../../utils/toast";

function View() {
  const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const { token } = useOutletContext();
  const [loader, setLoader] = useState(false);

  const runCronJob = async (path) => {
    try {
      setLoader(true);
      const response = await axios.get(`${API_BASE_URL}/cronjob/${path}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      if (response.data.message === "success") {
        toastr.success("CronJob Successfully triggered");
      }
    } catch (error) {
      toastr.error(error.response.data.message);
      setLoader(false);
    } finally {
      setLoader(false);
    }
  };
  return (
    <>
      <div className="content">
        <div className="d-md-flex d-block page-breadcrumb mb-3">
          <div className="my-auto mb-2">
            <h2 className="mb-1">CronJobs</h2>
            <p className="fs-14">Track and manage CronJobs</p>
          </div>
        </div>

        <div className="row">
          <div className="col-xl-12">
            <div className="card">
              <div className="card-body">
                <ul
                  className="nav nav-pills justify-content-center nav-style-2 mb-3"
                  role="tablist"
                >
                  <li className="nav-item">
                    <a
                      className="nav-link active"
                      data-bs-toggle="tab"
                      role="tab"
                      aria-current="page"
                      href="#home-center"
                      aria-selected="true"
                    >
                      Candidates
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      data-bs-toggle="tab"
                      role="tab"
                      aria-current="page"
                      href="#about-center"
                      aria-selected="false"
                    >
                      CompanyInfos
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      data-bs-toggle="tab"
                      role="tab"
                      aria-current="page"
                      href="#services-center"
                      aria-selected="false"
                    >
                      Services
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      data-bs-toggle="tab"
                      role="tab"
                      aria-current="page"
                      href="#contacts-center"
                      aria-selected="false"
                    >
                      Contacts
                    </a>
                  </li>
                </ul>
                <div className="tab-content">
                  <div
                    className="tab-pane show active text-muted"
                    id="home-center"
                    role="tabpanel"
                  >
                    <div className="row">
                      <div className="col-lg-3 col-md-6 d-flex">
                        <div className="card flex-fill">
                          <div className="card-body d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center overflow-hidden">
                              <div>
                                <p className="fs-14 fw-medium mb-1 text-dark fw-semibold">
                                  GDPR 45 Days Reminder
                                </p>
                              </div>
                            </div>
                            <div>
                              <span
                                style={{ cursor: "pointer" }}
                                disabled={loader}
                                onClick={() => {
                                  if (loader !== true) {
                                    if (
                                      window.confirm(
                                        "Are you sure you want to send reminder?",
                                      )
                                    ) {
                                      runCronJob(
                                        "candidates/sendGDPRReminder?days=45",
                                      );
                                    }
                                  } else {
                                    toastr.error("Please wait...");
                                  }
                                }}
                                className="avatar avatar-md bg-primary flex-shrink-0"
                              >
                                {loader ? (
                                  <i className="fa-solid fa-spinner fs-16"></i>
                                ) : (
                                  <i className="fa-solid fa-paper-plane fs-16"></i>
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6 d-flex">
                        <div className="card flex-fill">
                          <div className="card-body d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center overflow-hidden">
                              <div>
                                <p className="fs-14 fw-medium mb-1 text-dark fw-semibold">
                                  GDPR 90 Days Reminder
                                </p>
                              </div>
                            </div>
                            <div>
                              <span
                                style={{ cursor: "pointer" }}
                                disabled={loader}
                                onClick={() => {
                                  if (loader !== true) {
                                    if (
                                      window.confirm(
                                        "Are you sure you want to send reminder?",
                                      )
                                    ) {
                                      runCronJob(
                                        "candidates/sendGDPRReminder?days=90",
                                      );
                                    }
                                  } else {
                                    toastr.error("Please wait...");
                                  }
                                }}
                                className="avatar avatar-md bg-primary flex-shrink-0"
                              >
                                {loader ? (
                                  <i className="fa-solid fa-spinner fs-16"></i>
                                ) : (
                                  <i className="fa-solid fa-paper-plane fs-16"></i>
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6 d-flex">
                        <div className="card flex-fill">
                          <div className="card-body d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center overflow-hidden">
                              <div>
                                <p className="fs-14 fw-medium mb-1 text-dark fw-semibold">
                                  GDPR 180 Days Reminder
                                </p>
                              </div>
                            </div>
                            <div>
                              <span
                                style={{ cursor: "pointer" }}
                                disabled={loader}
                                onClick={() => {
                                  if (loader !== true) {
                                    if (
                                      window.confirm(
                                        "Are you sure you want to send reminder?",
                                      )
                                    ) {
                                      runCronJob(
                                        "candidates/sendGDPRReminder?days=180",
                                      );
                                    }
                                  } else {
                                    toastr.error("Please wait...");
                                  }
                                }}
                                className="avatar avatar-md bg-primary flex-shrink-0"
                              >
                                {loader ? (
                                  <i className="fa-solid fa-spinner fs-16"></i>
                                ) : (
                                  <i className="fa-solid fa-paper-plane fs-16"></i>
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-3 col-md-6 d-flex">
                        <div className="card flex-fill">
                          <div className="card-body d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center overflow-hidden">
                              <div>
                                <p className="fs-14 fw-medium mb-1 text-dark fw-semibold">
                                  GDPR Decrpyt
                                </p>
                              </div>
                            </div>
                            <div>
                              <span
                                style={{ cursor: "pointer" }}
                                disabled={loader}
                                onClick={() => {
                                  if (loader !== true) {
                                    if (
                                      window.confirm(
                                        "Are you sure you want to send reminder?",
                                      )
                                    ) {
                                      runCronJob(
                                        "candidates/sendGDPRReminder?days=0",
                                      );
                                    }
                                  } else {
                                    toastr.error("Please wait...");
                                  }
                                }}
                                className="avatar avatar-md bg-primary flex-shrink-0"
                              >
                                {loader ? (
                                  <i className="fa-solid fa-spinner fs-16"></i>
                                ) : (
                                  <i className="fa-solid fa-paper-plane fs-16"></i>
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane text-muted"
                    id="about-center"
                    role="tabpanel"
                  >
                    <div className="row">
                      <div className="col-lg-3 col-md-6 d-flex">
                        <div className="card flex-fill">
                          <div className="card-body d-flex align-items-center justify-content-between">
                            <div className="d-flex align-items-center overflow-hidden">
                              <div>
                                <p className="fs-14 fw-medium mb-1 text-dark fw-semibold">
                                  Check Add Prospect
                                </p>
                              </div>
                            </div>
                            <div>
                              <span
                                style={{ cursor: "pointer" }}
                                disabled={loader}
                                onClick={() => {
                                  if (loader !== true) {
                                    if (
                                      window.confirm(
                                        "Are you sure you want to scan candidates experience?",
                                      )
                                    ) {
                                      runCronJob("companyinfo/addProspect");
                                    }
                                  } else {
                                    toastr.error("Please wait...");
                                  }
                                }}
                                className="avatar avatar-md bg-primary flex-shrink-0"
                              >
                                {loader ? (
                                  <i className="fa-solid fa-spinner fs-16"></i>
                                ) : (
                                  <i className="fa-solid fa-paper-plane fs-16"></i>
                                )}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    className="tab-pane text-muted"
                    id="services-center"
                    role="tabpanel"
                  >
                    Unbelievable healthy snack success stories. 12 facts about
                    safe food handling tips that will impress your friends.
                    Restaurant weeks by the numbers. Will mexican food ever rule
                    the world? The 10 best thai restaurant youtube videos. How
                    restaurant weeks can make you sick. The complete beginner's
                    guide to cooking healthy food. Unbelievable food stamp
                    success stories. How whole foods markets are making the
                    world a better place. 16 things that won't happen in dish
                    reviews.
                  </div>
                  <div
                    className="tab-pane text-muted"
                    id="contacts-center"
                    role="tabpanel"
                  >
                    Why delicious magazines are killing you. Why our world would
                    end if restaurants disappeared. Why restaurants are on crack
                    about restaurants. How restaurants are making the world a
                    better place. 8 great articles about minute meals. Why our
                    world would end if healthy snacks disappeared. Why the world
                    would end without mexican food. The evolution of chef
                    uniforms. How not knowing food processors makes you a
                    rookie. Why whole foods markets beat peanut butter on
                    pancakes.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default View;
